// 打卡
import { request } from "@/utils/request";

// 获取指定员工指定日期考勤数据
export function getAttendanceByDay(params) {
  return request({
    url: "/employee/attendance/1.0/getAttendanceByDay",
    method: "POST",
    params,
  });
}
// 获取当前可考勤状态
export function getSignkt(params) {
  return request({
    url: "/employee/attendance/1.0/getSignkt",
    method: "POST",
    params,
  });
}
// 考勤打卡
export function attendanceSign(params) {
  return request({
    url: "/employee/attendance/1.0/attendanceSign",
    method: "POST",
    params,
  });
}
// 获取考勤打卡记录列表
export function getAttendanceList(params) {
  return request({
    url: "/employee/attendance/1.0/attendanceList",
    method: "POST",
    params,
  });
}
// 更新考勤
export function attendanceUpdateSign(params) {
  return request({
    url: "/employee/attendance/1.0/attendanceUpdateSign",
    method: "POST",
    params,
  });
}
